import React from 'react';
import { weight } from '../data/masterclass';
export function SuccessAddsWeight() {
  return <section aria-labelledby="weight-heading" className="border-t border-ink-line bg-ink-soft" data-id="element-124" data-mp="21spepn4556sw">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:py-20" data-id="element-125" data-mp="1nzq2btznnspk">
        <h2 id="weight-heading" className="text-center font-display text-6xl font-bold uppercase text-white sm:text-7xl lg:text-8xl" data-id="element-126" data-mp="1szm7hwk39q6p">
          Success adds <span className="text-gold" data-id="element-127" data-mp="1e4poqpenlkfd">weight.</span>
        </h2>

        <ul className="mt-12 grid gap-x-12 border-y border-ink-line sm:grid-cols-2" data-id="element-128" data-mp="1j2hh1kj7n8k3">
          {weight.lines.map(line => <li key={line} className="border-b border-ink-line py-5 text-2xl leading-snug text-white/75 last:border-b-0 sm:text-[1.75rem] sm:[&:nth-last-child(-n+2)]:border-b-0" data-id="element-129" data-mp="15400c6rq2wbo">
              {line}
            </li>)}
        </ul>

        <p className="mx-auto mt-14 max-w-4xl text-center font-display text-4xl font-bold uppercase leading-tight text-gold sm:text-5xl" data-id="element-130" data-mp="34ej0tinb31jv">
          Success isn’t the enemy. Unprepared infrastructure is.
        </p>

        <p className="mx-auto mt-6 max-w-3xl text-center text-lg leading-relaxed text-white/65" data-id="element-131" data-mp="37xcpsbq9qdij">
          {weight.close}
        </p>
      </div>
    </section>;
}